import React from 'react';

interface ButtonV2Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  desktopText: string;
  mobileText: string;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
}

const ButtonV2: React.FC<ButtonV2Props> = ({
  onClick,
  desktopText,
  mobileText,
  className = '',
  style,
  id,
  ...rest
}) => {
  return (
    <button
      id={id}
      style={style}
      className={`
        text-[#000000]
        roboto
        font-normal
        text-[13px]
        underline
        cursor-pointer
        bg-transparent
        transition-text
        duration-400
        capitalize
        border-none
        flex
        items-center
        gap-2
        col-start-1
        md:row-start-1
        self-center
        ${className}
      `}
      onClick={onClick}
      {...rest}
    >
      {/* arrow left icon */}
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-[#0A9281]"
      >
        <path
          d="M10 3L5 8L10 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 8H20"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* back button text - desktop */}
      <span className="hidden md:block">
        {desktopText}
      </span>

      {/* back button text - mobile */}
      <span className="block md:hidden">
        {mobileText}
      </span>
    </button>
  );
};

export default ButtonV2;
